const hasDefaultAvatar = (avatarUrl) => {
	return (avatarUrl && avatarUrl.includes("static")) || false;
};

export default hasDefaultAvatar;
